export const translations = {
    en: {
        // Navbar
        schoolName: "School of Intelligence",
        navAssessment: "Assessment",
        navLearning: "Learning",
        navSimulation: "Simulation",
        navCertified: "Badge & Pledge",

        // Hero
        heroTitlePrefix: "Test Your",
        heroTitleHighlight: "Human Intelligence",
        heroSubtitle: "Emotional. Ethical. Digital. Intelligence for the AI Era.",
        heroVersion: "V1.0 Public Release",
        heroHindiSubtitle: "अपनी मानवीय बुद्धिमत्ता को परखें।",
        heroCtaStart: "Start Free Assessment",
        heroCtaLearn: "Learn How It Works",
        animStat1: "Education ≠ Awareness",
        animStat2: "Information ≠ Intelligence",
        animStat3: "AI ≠ Wisdom",
        animStat4: "Speed ≠ Understanding",
        animStat5: "Connection ≠ Consciousness",
        animStat6: "Knowledge ≠ Judgment",
        trust1: "Free & Accessible",
        trust2: "No Personal Data Stored",
        trust3: "Built on CHREA Framework",

        // Reality Section
        realityTitle: "The World Is Getting Smarter.",
        realitySubtitle: "Are Humans Getting Wiser?",
        realityP1: "AI is advancing.",
        realityP2: "Scams are increasing.",
        realityP3: "Misinformation spreads faster than truth.",
        realityP4: "Emotional reactions dominate decisions.",
        realityConclusion: "Humans exists to change that.",

        // Philosophy
        aboutTitle: "About Us",
        aboutHeading: "A School of Intelligence for the Real World.",
        aboutDesc: "We do not teach subjects. We measure awareness.",
        aboutHindiDesc: "हम विषय नहीं सिखाते। हम जागरूकता मापते हैं।",
        pillarEmotional: "Emotional",
        pillarEthical: "Ethical",
        pillarDigital: "Digital",

        // Core Values (CHREA)
        valuesTitle: "Core Values",
        valuesSubtitle: "The CHREA Framework",
        val1Title: "Awareness First",
        val1Desc: "Intelligence begins with awareness.",
        val2Title: "Ethics Over Hype",
        val2Desc: "Technology must serve humanity, not manipulate it.",
        val3Title: "Responsibility in the Digital World",
        val3Desc: "Every click, share, and decision has impact.",
        val4Title: "Human Before Artificial",
        val4Desc: "AI can assist, but humans must lead.",
        val5Title: "Courage to Question",
        val5Desc: "True intelligence questions, verifies, and reflects.",

        // Framework Page Details
        frameworkSubtitle: "A 5-pillar system to navigate the age of Artificial Intelligence with Human Intelligence.",
        frameworkCourageDetail: "In a world of automated answers, the most valuable skill is asking the right questions. We prioritize critical inquiry over passive consumption.",
        frameworkHumanDetail: "We believe technology should amplify human potential, not replace connection, empathy, or creativity.",
        frameworkRespDetail: "Digital actions have real-world weight. We teach the long-term impact of clicks, shares, and algorithmic participation.",
        frameworkEthicsDetail: "Progress without principles is dangerous. We evaluate every technological advancement through the lens of human well-being.",
        frameworkAwarenessDetail: "You cannot manage what you do not notice. We cultivate deep attention and self-awareness as the foundation of intelligence.",

        // How It Works
        howTitle: "How It Works",
        step1: "Take Assessment",
        step2: "Watch Modules",
        step3: "Live Scenarios",
        step4: "Get Score",
        step5: "Get Badge",

        // Curriculum
        curriculumTitle: "Curriculum Overview",
        curriculumSubtitle: "A comprehensive, modular approach to elevating human intelligence in a synthetic world.",
        curr1Title: "Emotional Intelligence & Human Awareness",
        curr1Desc: "Master self-regulation and emotional anchoring in an attention-deficit economy.",
        curr2Title: "Cognitive & Ethical Thinking",
        curr2Desc: "Learn frameworks for unbiased decision-making and ethical technological interaction.",
        curr3Title: "AI, Digital Identity & Tech Literacy",
        curr3Desc: "Understand foundational AI mechanisms and secure your overarching digital fingerprint.",
        curr4Title: "Fraud & Digital Hygiene",
        curr4Desc: "Develop reflexes against targeted social engineering, deepfakes, and phishing vectors.",
        curr5Title: "Creative Thinking & Expression",
        curr5Desc: "Preserve uniquely human creativity and avoid algorithmic homogenization.",
        curr6Title: "Resilience & Leadership",
        curr6Desc: "Build adaptive capacity and lead with human-centric principles in tech-heavy environments.",
        curr7Title: "Future Building & Applied Wisdom",
        curr7Desc: "Synthesize intelligence models into actionable, long-term wisdom for future societies.",

        // Scenarios
        scenariosTitle: "Real-World Scenarios",
        scenariosDesc: "This is not theory. This is judgment under pressure. We simulate real-life threats to test your reflexive intelligence.",
        scenarioDeepfakeTitle: "Synthetic Voice Fraud",
        scenarioDeepfake: "Deepfake Detection",
        scenarioScamTitle: "Social Engineering",
        scenarioScam: "Scam Simulation",
        scenarioEthicalTitle: "Algorithmic Bias",
        scenarioEthical: "Ethical AI Decision Making",
        scenarioEmotionalTitle: "Attention Hijacking",
        scenarioEmotional: "Emotional Reaction Test",

        // Badge
        certTitle: "Badge & Pledge",
        certDesc: "Upon completion, you pledge to practice digital humanity and receive a meaningful badge.",
        certScore: "Score",
        certScoreDesc: "CHREA-based Intelligence Score",
        certBadge: "Badge",
        certBadgeDesc: "Digital representation of your pledge",

        // CTA
        ctaTitle: "Rebuilding Intelligence. Human First.",
        ctaSubtitle: "Start your journey today.",
        ctaButton: "Begin Assessment",
        ctaCard1Title: "Take the Assessment",
        ctaCard1Desc: "Measure your baseline humanity quotient against AI systems.",
        ctaCard1Btn: "Start Assessment →",
        ctaCard2Title: "Explore the Curriculum",
        ctaCard2Desc: "Dive into the deep-tech modules building the foundational framework.",
        ctaCard2Btn: "View Modules",

        // Assessment
        assessmentTitle: "Assessment Area",
        question: "Question",

        // Modules
        modulesTitle: "Intelligence Modules",
        modulesDesc: "Watch these short briefs before proceeding to the simulation.",
        moduleEmotional: "Emotional Control",
        moduleDigital: "Digital Verification",
        moduleEthical: "Ethical Decision Making",
        moduleCrisis: "Crisis Response",
        proceedSim: "Proceed to Simulation",
        videoModule: "Video Module",

        // Simulation
        simTitle: "Live Simulation",
        simScenario: "Scenario",

        // Certification Page
        profileTitle: "Intelligence Profile",
        verifiedComplete: "Verification Complete",
        iqLabel: "Intelligence Quotient (HQ)",
        uniqueCode: "Unique Verification Code",
        detailedAnalysis: "Detailed Analysis",
        retake: "Retake Assessment",
        share: "Share",
        download: "Download"
    },
    hi: {
        // Navbar
        schoolName: "स्कूल ऑफ इंटेलिजेंस",
        navAssessment: "मूल्यांकन",
        navLearning: "सीखना",
        navSimulation: "सिमुलेशन",
        navCertified: "बैज और संकल्प",

        // Hero
        heroTitlePrefix: "अपनी",
        heroTitleHighlight: "मानवीय बुद्धिमत्ता",
        heroTitleSuffix: "को परखें",
        heroSubtitle: "भावनात्मक। नैतिक। डिजिटल। एआई युग के लिए बुद्धिमत्ता।",
        heroVersion: "V1.0 सार्वजनिक रिलीज़",
        heroHindiSubtitle: "Test Your Human Intelligence.",
        heroCtaStart: "मुफ्त मूल्यांकन शुरू करें",
        heroCtaLearn: "यह कैसे काम करता है",
        animStat1: "शिक्षा ≠ जागरूकता",
        animStat2: "सूचना ≠ बुद्धिमत्ता",
        animStat3: "एआई ≠ ज्ञान",
        animStat4: "गति ≠ समझ",
        animStat5: "संपर्क ≠ चेतना",
        animStat6: "ज्ञान ≠ निर्णय",
        trust1: "मुफ़्त और सुलभ",
        trust2: "कोई व्यक्तिगत डेटा संग्रहीत नहीं",
        trust3: "CHREA फ्रेमवर्क पर निर्मित",

        // Reality Section
        realityTitle: "दुनिया होशियार हो रही है।",
        realitySubtitle: "क्या इंसान समझदार हो रहे हैं?",
        realityP1: "एआई आगे बढ़ रहा है।",
        realityP2: "घोटाले बढ़ रहे हैं।",
        realityP3: "गलत सूचना सच से भी तेज फैलती है।",
        realityP4: "फैसलों पर जज्बात हावी होते हैं।",
        realityConclusion: "ह्यूमन्स इसे बदलने के लिए यहाँ है।",

        // Philosophy
        aboutTitle: "हमारे बारे में",
        aboutHeading: "असली दुनिया के लिए एक स्कूल ऑफ इंटेलिजेंस।",
        aboutDesc: "हम विषय नहीं सिखाते। हम जागरूकता मापते हैं।",
        aboutHindiDesc: "We do not teach subjects. We measure awareness.",
        pillarEmotional: "भावनात्मक",
        pillarEthical: "नैतिक",
        pillarDigital: "डिजिटल",

        // Core Values (CHREA)
        valuesTitle: "महत्वपूर्ण मूल्य",
        valuesSubtitle: "CHREA फ्रेमवर्क",
        val1Title: "जागरूकता सबसे पहले",
        val1Desc: "बुद्धिमत्ता की शुरुआत जागरूकता से होती है।",
        val2Title: "प्रचार से ऊपर नैतिकता",
        val2Desc: "तकनीक मानवता की सेवा करे, उसे नियंत्रित न करे।",
        val3Title: "डिजिटल दुनिया में जिम्मेदारी",
        val3Desc: "हर क्लिक, हर शेयर और हर निर्णय का प्रभाव होता है।",
        val4Title: "कृत्रिम से पहले मानवीय",
        val4Desc: "AI सहायता कर सकता है, नेतृत्व मनुष्य का होना चाहिए।",
        val5Title: "प्रश्न करने का साहस",
        val5Desc: "सच्ची बुद्धिमत्ता प्रश्न करती है, सत्यापित करती है और चिंतन करती है।",

        // Framework Page Details
        frameworkSubtitle: "मानवीय बुद्धिमत्ता के साथ आर्टिफिशियल इंटेलिजेंस के युग में नेविगेट करने के लिए 5-स्तंभ प्रणाली।",
        frameworkCourageDetail: "स्वचालित उत्तरों की दुनिया में, सबसे मूल्यवान कौशल सही सवाल पूछना है। हम निष्क्रिय खपत पर आलोचनात्मक जांच को प्राथमिकता देते हैं।",
        frameworkHumanDetail: "हम मानते हैं कि तकनीक को मानवीय क्षमता को बढ़ाना चाहिए, कनेक्शन, सहानुभूति या रचनात्मकता को प्रतिस्थापित नहीं करना चाहिए।",
        frameworkRespDetail: "डिजिटल कार्यों का वास्तविक दुनिया पर प्रभाव पड़ता है। हम क्लिक, शेयर और एल्गोरिथम भागीदारी के दीर्घकालिक प्रभाव को सिखाते हैं।",
        frameworkEthicsDetail: "सिद्धांतों के बिना प्रगति खतरनाक है। हम मानव कल्याण के लेंस के माध्यम से हर तकनीकी प्रगति का मूल्यांकन करते हैं।",
        frameworkAwarenessDetail: "आप उसे प्रबंधित नहीं कर सकते जिसे आप नोटिस नहीं करते हैं। हम बुद्धिमत्ता की नींव के रूप में गहरी ध्यान और आत्म-जागरूकता विकसित करते हैं।",

        // How It Works
        howTitle: "यह कैसे काम करता है",
        step1: "मूल्यांकन करें",
        step2: "मॉड्यूल देखें",
        step3: "लाइव परिदृश्य",
        step4: "स्कोर प्राप्त करें",
        step5: "बैज प्राप्त करें",

        // Curriculum
        curriculumTitle: "पाठ्यक्रम रूपरेखा",
        curriculumSubtitle: "एक सिंथेटिक दुनिया में मानव बुद्धि को बढ़ाने के लिए एक व्यापक, मॉड्यूलर दृष्टिकोण।",
        curr1Title: "भावनात्मक बुद्धिमत्ता और मानव जागरूकता",
        curr1Desc: "ध्यान-अभाव अर्थव्यवस्था में आत्म-नियमन और भावनात्मक एंकरिंग में महारत हासिल करें।",
        curr2Title: "संज्ञानात्मक और नैतिक सोच",
        curr2Desc: "निष्पक्ष निर्णय लेने और नैतिक तकनीकी बातचीत के लिए रूपरेखा सीखें।",
        curr3Title: "एआई, डिजिटल पहचान और तकनीकी साक्षरता",
        curr3Desc: "मूलभूत एआई तंत्र को समझें और अपने समग्र डिजिटल फिंगरप्रिंट को सुरक्षित करें।",
        curr4Title: "धोखाधड़ी और डिजिटल स्वच्छता",
        curr4Desc: "लक्षित सामाजिक इंजीनियरिंग, डीपफेक और फ़िशिंग वैक्टर के खिलाफ सजगता विकसित करें।",
        curr5Title: "रचनात्मक सोच और अभिव्यक्ति",
        curr5Desc: "विशिष्ट मानवीय रचनात्मकता को सुरक्षित रखें और एल्गोरिदमिक समरूपीकरण से बचें।",
        curr6Title: "लचीलापन और नेतृत्व",
        curr6Desc: "अनुकूली क्षमता का निर्माण करें और तकनीकी-भारी वातावरण में मानव-केंद्रित सिद्धांतों के साथ नेतृत्व करें।",
        curr7Title: "भविष्य निर्माण और अनुप्रयुक्त ज्ञान",
        curr7Desc: "भविष्य के समाजों के लिए कार्रवाई योग्य, दीर्घकालिक ज्ञान में खुफिया मॉडल का संश्लेषण करें।",

        // Scenarios
        scenariosTitle: "वास्तविक दुनिया के परिदृश्य",
        scenariosDesc: "यह सिद्धांत नहीं है। यह दबाव में लिया गया निर्णय है। हम आपकी सजगता का परीक्षण करने के लिए वास्तविक खतरों का अनुकरण करते हैं।",
        scenarioDeepfakeTitle: "सिंथेटिक वॉयस फ्रॉड",
        scenarioDeepfake: "डीपफेक का पता लगाना",
        scenarioScamTitle: "सोशल इंजीनियरिंग",
        scenarioScam: "घोटाला सिमुलेशन",
        scenarioEthicalTitle: "एल्गोरिथम पूर्वाग्रह",
        scenarioEthical: "नैतिक एआई निर्णय",
        scenarioEmotionalTitle: "अटेंशन हाईजैकिंग",
        scenarioEmotional: "भावनात्मक प्रतिक्रिया परीक्षण",

        // Badge
        certTitle: "बैज और मान्यता",
        certDesc: "पूरा होने पर, आप डिजिटल मानवता का अभ्यास करने का संकल्प लेते हैं और एक सार्थक बैज प्राप्त करते हैं।",
        certScore: "स्कोर",
        certScoreDesc: "CHREA-आधारित इंटेलिजेंस स्कोर",
        certBadge: "बैज",
        certBadgeDesc: "आपके संकल्प का डिजिटल प्रतिनिधित्व",

        // CTA
        ctaTitle: "बुद्धिमत्ता का पुनर्निर्माण। इंसान सबसे पहले।",
        ctaSubtitle: "आज ही अपनी यात्रा शुरू करें।",
        ctaButton: "मूल्यांकन शुरू करें",
        ctaCard1Title: "मूल्यांकन लें",
        ctaCard1Desc: "एआई सिस्टम के मुकाबले अपने मूल मानवता भागफल को मापें।",
        ctaCard1Btn: "मूल्यांकन शुरू करें →",
        ctaCard2Title: "पाठ्यक्रम का अन्वेषण करें",
        ctaCard2Desc: "मूल्यांकन ढांचे के निर्माण वाले डीप-टेक मॉड्यूल में गोता लगाएँ।",
        ctaCard2Btn: "मॉड्यूल देखें",

        // Assessment
        assessmentTitle: "मूल्यांकन क्षेत्र",
        question: "प्रश्न",

        // Modules
        modulesTitle: "इंटेलिजेंस मॉड्यूल",
        modulesDesc: "सिमुलेशन के लिए आगे बढ़ने से पहले इन छोटे संक्षिप्त वीडियो को देखें।",
        moduleEmotional: "भावनात्मक नियंत्रण",
        moduleDigital: "डिजिटल सत्यापन",
        moduleEthical: "नैतिक निर्णय",
        moduleCrisis: "संकट प्रतिक्रिया",
        proceedSim: "सिमुलेशन के लिए आगे बढ़ें",
        videoModule: "वीडियो मॉड्यूल",

        // Simulation
        simTitle: "लाइव सिमुलेशन",
        simScenario: "परिदृश्य",

        // Certification Page
        profileTitle: "इंटेलिजेंस प्रोफाइल",
        verifiedComplete: "सत्यापन पूर्ण",
        iqLabel: "इंटेलिजेंस भागफल (HQ)",
        uniqueCode: "अद्वितीय सत्यापन कोड",
        detailedAnalysis: "विस्तृत विश्लेषण",
        retake: "मूल्यांकन फिर से करें",
        share: "साझा करें",
        download: "डाउनलोड करें"
    }
};
